import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CODE, COMP_TYPE, LOGON_INFO } from '../app.constants';
import { Code, CommonService } from '../app.service';
import { MessageService } from '../common/message.service';
import { Company, CompanyService } from '../member-kanri/company.service';
import { StateTotalService, TotalBillNew, TotalStatement } from './state-total.service';


import $ from 'jquery';


@Component({
    selector: 'state-total-new',
    templateUrl: 'state-total-new.component.html',
    providers: [CompanyService, StateTotalService]
})
export class StateTotalComponentNew implements OnInit {

    branchList: Company[] = [];
    totalList: TotalStatement[] = [];
    compnameDaiko: string[] = [];
    compnameEtc: string[] = [];
    compCountDaiko: number = 0;
    compCountEtc: number = 0;
    dataCount: number = 0;
    groupedBilling: {} = {};

    stateTotalList: any[] = [];
    businessIncome: TotalStatement[] = [];
    relatedIncome: TotalStatement[] = [];
    printState: TotalStatement[] = [];
    searchBranch: string;
    totalBill: TotalBillNew[] = [];

    today: Date;
    arrYear: number[] = Array.from({ length: 2099 - 1994 + 1 }, (_, i) => i + 1994);
    arrMonth: number[] = Array.from({ length: 12 }, (_, i) => i + 1);
    searchYear: string;
    searchMonth: string;

    stateCltrList: Code[];
    cltrCount: number = 0;
    cltrArea: string[] = [];

    chargeArray: string[] = [];

    firstWidth: number = 0;
    secondWidth: number = 0;

    cltrName: string[] = [];


    constructor(
        public router: Router,
        public commonService: CommonService,
        public companyService: CompanyService,
        public messageService: MessageService,
        public totalService: StateTotalService,
    ) { }

    ngOnInit() {
        this.today = new Date();
        this.searchYear = this.today.getFullYear().toString();
        this.searchMonth = (this.today.getMonth() + 1).toString();

        this.searchBranch = LOGON_INFO.COMP_ID;
        this.stateCltrList = CODE.STATE_CLTR;

        this.refreshPage();

        this.getBranchList();
    }


    /**
     * 明細リスト取得
     */
    getBillList() {
        this.totalService.getBranchTotalBill(this.searchBranch, this.searchYear, this.searchMonth)
            .subscribe(
                data => {
                    this.totalBill = data;
                    // console.log('totalBill?!', this.totalBill);

                    this.getTotalList();
                }
            )
    }

    getTotalList() {
        // this.commonService.showLoading();

        this.totalService.getBranchTotalList(this.searchBranch, this.searchYear, this.searchMonth)
            .subscribe(
                data => {
                    // console.log('data?!', data);
                    this.stateTotalList = [];

                    if (data.length == 0) {
                        // 明細、請求付帯なし
                        this.dataCount = data.length;
                        this.commonService.hideLoading();

                        return;
                    }

                    // Deep copy
                    let billArray = JSON.parse(JSON.stringify(this.totalBill));

                    let tempStateTotalList = [];
                    let dataLen = 0;
                    this.totalList = data;
                    this.totalList = data.filter((obj: any) => obj.total_amount !== 0 || obj.total_margin !== 0);

                    // 大興の場合は「所属」を表示、以外は「社名」を表示
                    const filterArrayDaiko = this.totalList.filter(obj => obj.parent_comp_name === '㈱大興' || obj.parent_comp_name === '（株）大興').map(obj => obj.comp_name);
                    // const filterArrayDaiko = this.totalList.filter(obj => obj.parent_comp_name === '㈱大興').map(obj => obj.comp_name);
                    const filterArrayEtc = this.totalList.filter(obj => obj.parent_comp_name !== '㈱大興' && obj.parent_comp_name !== '（株）大興').map(obj => obj.parent_comp_name);
                    // const filterArrayEtc = this.totalList.filter(obj => obj.parent_comp_name !== '㈱大興').map(obj => obj.parent_comp_name);
                    this.compnameDaiko = filterArrayDaiko.filter((item, index) => filterArrayDaiko.indexOf(item) === index).sort();
                    this.compnameEtc = filterArrayEtc.filter((item, index) => filterArrayEtc.indexOf(item) === index).sort();

                    // console.log('filterArrayEtc?!?!', filterArrayEtc);
                    // console.log('compnameEtc?!?!', this.compnameEtc);

                    this.compCountDaiko = this.compnameDaiko.length;
                    // if (this.compCountDaiko == 0)       this.compnameDaiko.push('');
                    this.compCountEtc = this.compnameEtc.length;
                    // if (this.compCountEtc == 0)       this.compnameEtc.push('');

                    // 「付帯事業収入（その他）」の表示
                    const filterArrayBill = billArray.filter(obj => obj.import_name !== '付帯事業収入').map(obj => obj.import_name);
                    this.cltrName = filterArrayBill.filter((item, index) => filterArrayBill.indexOf(item) === index).sort();
                    this.cltrCount = this.cltrName.length;

                    // 「請求先」によるグルーピング
                    this.groupedBilling = this.totalList.reduce((acc, obj) => {
                        const key = obj.billing_comp;
                        if (!acc[key]) {
                            acc[key] = [];
                        }
                        acc[key].push(obj);

                        return acc;
                    }, {});

                    const billCount = Object.keys(this.groupedBilling).length;
                    billArray.forEach(obj => {
                        if (obj.customer_comp == "（高速代）" || obj.customer_comp == "（高速代以外）") {
                            if (!this.chargeArray.includes(obj.billing_comp)) this.chargeArray.push(obj.billing_comp);
                        }
                    })

                    // 「得意先」によるグルーピング
                    for (let i = 0; i < billCount; i++) {
                        const key = Object.keys(this.groupedBilling)[i];

                        const groupedCustomer = this.groupedBilling[key];

                        const rdcCustomer = groupedCustomer.reduce((acc, obj) => {
                            // 品名に「高速代」がある場合、得意先に高速代を追加
                            let transKey = obj.product_category == "高速代" ? "（高速代）" : "";

                            let custKey = '';
                            // まとめ確認？
                            if (this.chargeArray.includes(key)) {
                                custKey = obj.product_category == "高速代" ? "（高速代）" : "（高速代以外）";
                            } else custKey = obj.customer_comp ? obj.customer_comp + transKey : "" + transKey;

                            if (!acc[custKey]) {
                                acc[custKey] = [];
                            }
                            acc[custKey].push(obj);

                            return acc;
                        }, {});

                        for (let j = 0; j < Object.keys(rdcCustomer).length; j++) {
                            const rdcKey = Object.keys(rdcCustomer)[j]
                            let totalSum = 0;

                            // 「請求額」
                            rdcCustomer[rdcKey].forEach(obj => {
                                totalSum += obj.total_margin;
                            })
                            // 「未払運賃」
                            const sum = rdcCustomer[rdcKey].reduce((acc, val) => {
                                if (val.parent_comp_name !== '㈱大興' && val.parent_comp_name !== '（株）大興') return acc + (val.total_amount == null ? 0 : val.total_amount);
                                else return acc + 0;
                            }, 0);

                            tempStateTotalList[dataLen] = [];
                            tempStateTotalList[dataLen].push(key);          //得意先（請求先）
                            tempStateTotalList[dataLen].push(rdcKey);       //得意先

                            const chargeIdx = billArray.findIndex((b) => b.billing_comp === key && b.customer_comp === (rdcKey ? rdcKey : null) && b.import_name === "付帯事業収入");
                            tempStateTotalList[dataLen].push(chargeIdx >= 0 ? totalSum + billArray[chargeIdx].charge : totalSum);     //請求額
                            tempStateTotalList[dataLen].push(chargeIdx >= 0 ? billArray[chargeIdx].charge : 0);     //付帯事業収入
                            if (chargeIdx >= 0) billArray.splice(chargeIdx, 1);

                            // 付帯事業収入（その他）
                            let totalArr: any;
                            totalArr = billArray.filter(tb => tb.billing_comp === key && tb.customer_comp === (rdcKey ? rdcKey : null) && tb.import_name !== "付帯事業収入");
                            if (totalArr.length > 0) {
                                this.cltrName.forEach(cn => {
                                    const cltrCharge = totalArr.find(ta => ta.import_name === cn)
                                    tempStateTotalList[dataLen].push(cltrCharge ? cltrCharge.charge : 0);
                                })
                            } else {
                                for (let l = 0; l < this.cltrCount; l++)   tempStateTotalList[dataLen].push(0);
                            }

                            // 運送事業収入
                            this.compnameDaiko.forEach(e => {
                                if (this.chargeArray.includes(key)) {
                                    const checkArr = rdcCustomer[rdcKey].filter(arr => arr.comp_name === e);
                                    let checkSum = 0;
                                    checkArr.forEach(obj => {
                                        if (obj.parent_comp_name === '㈱大興' || obj.parent_comp_name === '（株）大興') checkSum += obj.total_margin;
                                    })
                                    tempStateTotalList[dataLen].push(checkSum);
                                } else {
                                    const checkSum = rdcCustomer[rdcKey].filter(arr => arr.comp_name === e && (arr.parent_comp_name === '㈱大興' || arr.parent_comp_name === '（株）大興')).reduce((acc, obj) => acc + (obj.total_margin == null ? 0 : obj.total_margin), 0);
                                    tempStateTotalList[dataLen].push(checkSum);
                                }
                            })
                            tempStateTotalList[dataLen].push(sum);       //未払運賃

                            let sundry = 0;
                            for (let k = 3; k < tempStateTotalList[dataLen].length; k++) {
                                sundry += tempStateTotalList[dataLen][k];
                            }
                            tempStateTotalList[dataLen].push(totalSum - sundry);        //雑収入

                            // 社名別入力
                            this.compnameEtc.forEach(e => {
                                if (this.chargeArray.includes(key)) {
                                    const checkArr = rdcCustomer[rdcKey].filter(arr => arr.parent_comp_name === e);
                                    let checkSum = 0;
                                    checkArr.forEach(obj => {
                                        checkSum += obj.total_amount;
                                    })
                                    tempStateTotalList[dataLen].push(checkSum);
                                } else {
                                    const checkSum = rdcCustomer[rdcKey].filter(arr => arr.parent_comp_name === e).reduce((acc, obj) => acc + (obj.total_amount == null ? 0 : obj.total_amount), 0);
                                    tempStateTotalList[dataLen].push(checkSum);
                                }
                            })

                            if (totalArr.length > 0) billArray = billArray.filter(obj => !(obj.billing_comp === key && obj.customer_comp === (rdcKey ? rdcKey : null)));

                            dataLen++;
                        }
                    }

                    // 「請求額」がない場合
                    if (billArray.length > 0) {
                        const rdcBill = billArray.reduce((acc, obj) => {
                            const key = obj.billing_comp + '//' + obj.customer_comp;
                            if (!acc[key]) {
                                acc[key] = [];
                            }
                            acc[key].push(obj);

                            return acc;
                        }, {});
                        // console.log('rdcBill?!', rdcBill);

                        for (let i = 0; i < Object.keys(rdcBill).length; i++) {
                            tempStateTotalList[dataLen] = [];
                            tempStateTotalList[dataLen].push(rdcBill[Object.keys(rdcBill)[i]][0].billing_comp);                 //得意先（請求先）
                            tempStateTotalList[dataLen].push(rdcBill[Object.keys(rdcBill)[i]][0].customer_comp
                                ? rdcBill[Object.keys(rdcBill)[i]][0].customer_comp : '');          //得意先

                            // 付帯事業収入
                            const billIdx = rdcBill[Object.keys(rdcBill)[i]].find(obj => obj.import_name === "付帯事業収入");
                            tempStateTotalList[dataLen].push(billIdx ? billIdx.charge : 0);                                                                //請求額
                            tempStateTotalList[dataLen].push(billIdx ? billIdx.charge : 0);
                            // 付帯事業収入（その他）
                            this.cltrName.forEach(cn => {
                                const cltrCharge = rdcBill[Object.keys(rdcBill)[i]].find(ta => ta.import_name === cn)
                                tempStateTotalList[dataLen].push(cltrCharge ? cltrCharge.charge : 0);
                            })

                            for (let j = 0; j < tempStateTotalList[0].length - 4 - this.cltrCount; j++) {
                                tempStateTotalList[dataLen].push(0);
                            }

                            dataLen++;
                        }
                    }

                    const tempList = tempStateTotalList[0].length;

                    tempStateTotalList[dataLen] = [];
                    tempStateTotalList[dataLen].push('合計');
                    tempStateTotalList[dataLen].push('-');

                    for (let i = 2; i < tempList; i++) {
                        let sum = 0;
                        for (let j = 0; j < dataLen; j++) {
                            sum += tempStateTotalList[j][i];
                        }
                        tempStateTotalList[dataLen].push(sum);
                    }

                    this.stateTotalList = tempStateTotalList;
                    this.dataCount = this.stateTotalList.length - 1;

                    this.commonService.hideLoading();

                    // 1~3列の固定範囲を確認
                    $(document).ready(() => {
                        this.firstWidth = $('#first_header').outerWidth();
                        this.secondWidth = $('#second_header').outerWidth();
                    });
                    // console.log('stateTotalList?!', this.stateTotalList);
                }
            )
    }


    /**
     * 営業所リストを取得（権限は本社のみ？）
     */
    getBranchList() {
        if (LOGON_INFO.COMP_TYPE == COMP_TYPE.HEAD || LOGON_INFO.COMP_TYPE == COMP_TYPE.BRANCH) {
            this.branchList = this.companyService.getCompanyListForCombo();
        }
    }

    //画面リフレッシュ
    refreshPage(): void {
        this.commonService.showLoading();

        this.cltrCount = 0;
        this.compnameDaiko = [];
        this.totalBill = [];
        this.chargeArray = [];

        this.getBillList();
        // this.getTotalList();
    }


    toLocaleString(sArray: any) {
        sArray.forEach(sa => {
            if (sa.total_margin) sa.total_margin = sa.total_margin.toLocaleString();
        });
    }

    stateTotalModalShow(compname: string, custname: any, position: number) {
        const isTrans = custname.search('（高速代）');
        let custArray = [];

        // if (position === 0)                     return;
        if (compname === '合計') return;
        if (!this.groupedBilling[compname]) return;
        if (custname === '') custname = null;

        this.commonService.showLoading();
        this.businessIncome = [];
        this.relatedIncome = [];

        if (this.chargeArray.includes(compname)) {
            // Deep copy
            let compArray = JSON.parse(JSON.stringify(this.groupedBilling[compname]));

            // 「高速代抜く」と「高速代」で区分する
            if (isTrans < 0) compArray = compArray.filter(e => e.product_category != '高速代');
            else compArray = compArray.filter(e => e.product_category == '高速代');

            compArray.forEach(e => {
                if (e.parent_comp_name == '㈱大興' || e.parent_comp_name == '（株）大興') {
                    let daikoIdx = custArray.findIndex(f => e.comp_name == f.comp_name)

                    if (daikoIdx < 0) custArray.push(e);
                    else custArray[daikoIdx].total_margin += e.total_margin;
                }
                else {
                    let compIdx = custArray.findIndex(f => e.parent_comp_name == f.parent_comp_name)

                    if (compIdx < 0) custArray.push(e);
                    else custArray[compIdx].total_amount += e.total_amount;
                }
            })
        } else {
            const srcCustname = (isTrans > 0) ? custname.slice(0, isTrans) : custname;
            custArray = this.groupedBilling[compname].filter(e => e.customer_comp == srcCustname);

            if (isTrans < 0) custArray = custArray.filter(e => e.product_category != '高速代');
            else custArray = custArray.filter(e => e.product_category == '高速代');
        }

        custArray.forEach(e => {
            if (e.parent_comp_name == '㈱大興' || e.parent_comp_name == '（株）大興') this.businessIncome.push(e);
            else this.relatedIncome.push(e);
        })
        $('#stateTotalModal').modal('show');

        // this.toLocaleString(this.businessIncome);
        // this.toLocaleString(this.relatedIncome);

        this.businessIncome.sort((a, b) => {
            if (a.comp_name > b.comp_name) return 1;
            if (a.comp_name < b.comp_name) return -1;
            return 0;
        })
        this.relatedIncome.sort((a, b) => {
            if (a.parent_comp_name > b.parent_comp_name) return 1;
            if (a.parent_comp_name < b.parent_comp_name) return -1;
            return 0;
        })

        this.commonService.hideLoading();
    }

    branchStateSearch() {
        this.refreshPage();
    }

    stateTotalExportAsExcelJs() {

        let title: any[] = [];
        const columnStyle = {
            style: { font: { size: 10, name: 'メイリオ' }, alignment: { shrinkToFit: true }, border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } } }
        };

        // title.push(
        //     { ...columnStyle, header: '請求先', key: 'index', width: 25 }
        //     , { ...columnStyle, header: '得意先', key: 'index', width: 25 }
        //     , { ...columnStyle, header: '請求額', key: 'index', width: 12 }
        //     , { ...columnStyle, header: '付帯事業収入', key: 'index', width: 12 }
        // );
        // this.cltrArea.forEach(e => title.push({ ...columnStyle, header: e, key: 'index', width: 12 }));
        // this.compnameDaiko.forEach(e => title.push({ ...columnStyle, header: e, key: 'index', width: 12 }));
        // title.push(
        //     { ...columnStyle, header: '未払運賃', key: 'index', width: 12 }
        //     , { ...columnStyle, header: '雑収入', key: 'index', width: 12 }
        // );
        // this.compnameEtc.forEach(e => title.push({ ...columnStyle, header: e, key: 'index', width: 12 }));

        title = this.cltrName.concat(this.compnameDaiko.concat(['未払運賃', '雑収入'].concat(this.compnameEtc)));
        const fileName = this.searchYear + (this.searchMonth.length == 1 ? '0' + this.searchMonth : this.searchMonth) + "_" + this.branchList.find(f => f.comp_id === this.searchBranch).name;

        this.commonService.printBillTotalExcelJs(title, this.stateTotalList, '明細合計_' + fileName, this.cltrCount, this.compCountDaiko);
    }

    ngOnDestroy() {
        //Modalが開いた状態でブラウザの前ページへ移動ボタン押下すると、modalは閉じられるがbackdropが消えない
        //強制的にbackdropを消す
        $(".modal-backdrop").remove();
    }
}



// WEBPACK FOOTER //
// ./src/app/statement/state-total-new.component.ts